import { render } from "./RolePermissionsEditor.vue?vue&type=template&id=39a6e390&scoped=true"
import script from "./RolePermissionsEditor.vue?vue&type=script&lang=js"
export * from "./RolePermissionsEditor.vue?vue&type=script&lang=js"

import "./RolePermissionsEditor.vue?vue&type=style&index=0&id=39a6e390&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a6e390"]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox,QList,QItem,QItemSection,QItemLabel});
